/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FormBuilderFieldTypes {
  ShortText = 0,
  BigText = 1,
  Integer = 2,
  DecimalNumber = 3,
  Date = 4,
  Time = 5,
  MobileNumber = 6,
  NationalCode = 7,
  Email = 8,
  SelectList = 9,
  Regex = 10,
  Boolean = 11,
  File = 12
}
